export type EventUnsubscribe = () => void;

export type EventHandler<TIn = void, TOut = Promise<void>> = (arg: TIn) => TOut;

export class HandlerCollection<TIn = void, TOut = Promise<void>> {
	private handlers: Array<EventHandler<TIn, TOut>> = [];
	public add(handler: EventHandler<TIn, TOut>): EventUnsubscribe {
		this.handlers.push(handler);
		return () => {
			this.handlers.splice(this.handlers.indexOf(handler), 1);
		};
	}

	public async execute(arg: TIn) {
		const settled = await Promise.allSettled(this.handlers.map((handler) => handler(arg)));
		return settled.map((run) => {
			if (run.status === 'rejected' && run.reason) {
				console.error('Failed to execute foreground process event:', run.reason);
			}
			if (run.status === 'fulfilled') {
				return run.value;
			}
			return;
		});
	}
}
